// Mock data for roadside assistance website

export const services = [
  {
    id: 1,
    title: 'Lastik Tamiri & Değişimi',
    description: 'Patlak lastik mi? Hemen yerinize gelip lastik tamiri veya değişimi yapıyoruz. 7/24 hızlı servis.',
    icon: 'Wrench',
    features: ['Profesyonel ekip', 'Hızlı servis', 'Uygun fiyat', 'Kaliteli malzeme']
  },
  {
    id: 2,
    title: 'Akü Takviye & Değişimi',
    description: 'Aracınızın aküsü mü bitti? Anında yerinize gelip akü takviyesi yapıyor veya yeni akü takıyoruz.',
    icon: 'Battery',
    features: ['Anında takviye', 'Yeni akü tedariki', '7/24 hizmet', 'Uzman ekip']
  },
  {
    id: 3,
    title: 'Mobil Yol Yardım',
    description: 'Her türlü yol yardımı için bize ulaşın. Kadıköy bölgesinde hızlı ve güvenilir hizmet.',
    icon: 'Car',
    features: ['7/24 ulaşılabilir', 'Hızlı müdahale', 'Tüm Kadıköy', 'Güvenilir hizmet']
  }
];

export const coverageAreas = [
  'Acıbadem', 'Bağlarbaşı', 'Caferağa', 'Caddebostan', 'Erenköy',
  'Fenerbahçe', 'Feneryolu', 'Fikirtepe', 'Göztepe', 'Hasanpaşa',
  'Koşuyolu', 'Kozyatağı', 'Moda', 'Osmanağa', 'Rasimpaşa',
  'Sahrayıcedit', 'Suadiye', 'Zühtüpaşa'
];

export const whatsappNumber = '905534834264';
export const whatsappLink = `https://wa.me/${whatsappNumber}?text=Merhaba, yol yardım hizmeti almak istiyorum.`;

export const aboutInfo = {
  title: 'Hakkımızda',
  description: 'İstanbul Kadıköy bölgesinde 7/24 mobil yol yardım hizmeti sunuyoruz. Uzman ekibimiz ile lastik tamiri, akü takviyesi ve acil yol yardımı konularında hızlı ve güvenilir çözümler sağlıyoruz.',
  features: [
    { title: 'Profesyonel Ekip', description: 'Deneyimli ve sertifikalı teknisyenler' },
    { title: '7/24 Hizmet', description: 'Her gün, her saat hizmetinizdeyiz' },
    { title: 'Hızlı Müdahale', description: 'Ortalama 20-30 dakikada yerinizde' },
    { title: 'Uygun Fiyat', description: 'Şeffaf ve rekabetçi fiyatlandırma' }
  ]
};

export const contactInfo = {
  phone: '0553 483 42 64',
  whatsapp: '0553 483 42 64',
  email: 'info@yolyardim.com',
  address: 'Kadıköy, İstanbul',
  workingHours: '7/24 Hizmet'
};